export default __webpack_public_path__ + "static/media/eyepatch.ad306309.jpg";